<template>
  <div>
    <v-data-table :headers="headers"
                  :items="paymentPlan.installments"
                  class="mt-4"
                  hide-default-footer
                  :mobile-breakpoint="0"
                  :items-per-page="-1"
                  :class="{ 'elevation-1': $vuetify.breakpoint.smAndDown }">
      <template #item.sequence="{ item }">
        <td>
          <v-badge color="grey" v-if="item.paid < item.eur">
            <span slot="badge">{{ item.sequence }}</span>
          </v-badge>
          <v-badge color="color-green" v-else>
            <span slot="badge">{{ item.sequence }}</span>
          </v-badge>
        </td>
      </template>
      <template #item.duedate="{ item }">
        {{ item.duedate | formatDate }}
      </template>
      <template #item.eur="{ item }">
        {{ item.eur | currency }}
      </template>
      <template #item.paid="{ item }">
        {{ item.paid | currency }}
      </template>
      <template #item.debtLeft="{ item }">
        {{ item.debtLeft | currency }}
      </template>
    </v-data-table>
    <p class="mt-3" v-if="showPaymentplanInterestNotation">{{ $t('paymentPlanInterestNotion') }}</p>
  </div>
</template>

<script>
  export default {
    props: ['paymentPlan'],
    computed: {
      headers () {
        let desktopHeaders = [
          { text: this.$t('installment'), value: 'sequence' },
          { text: this.$t('dueDate'), value: 'duedate' },
          { text: this.$t('installmentTotal'), value: 'eur' },
          { text: this.$t('paid'), value: 'paid' },
          { text: this.$t('debtLeft'), value: 'debtLeft' }
        ]

        let mobileHeaders = [
          { text: this.$t('installment'), value: 'sequence' },
          { text: this.$t('dueDate'), value: 'duedate' },
          { text: this.$t('installmentTotal'), value: 'eur' },
          { text: this.$t('paid'), value: 'paid' }
        ]

        return this.$vuetify.breakpoint.smAndDown ? mobileHeaders : desktopHeaders
      },
      showPaymentplanInterestNotation () {
        return this.paymentPlan.paymentPlanType !== 7 && this.paymentPlan.debts[0].debtSummary.state.state !== 6
      }
    }
  }
</script>
